module.exports = __webpack_public_path__ + "static/img/exercises.2dd1a19a.svg";